export default "__VITE_ASSET__Ctkqnl9r__"